import { Button, Card, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from "react-router-dom";


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0,
    paddingBottom: "0 !important"
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const AccountWallet = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.account);
  const wallet = model.credit_wallet;
  const classes = useStyles();

  if (!wallet) return null;

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Credit Wallet" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>
                {wallet.currency}
                <div><Typography variant="caption">{wallet.reference}</Typography></div>
              </TableCell>
              <TableCell>
                {wallet.balance.toFixed(2)}
                <div><Typography variant="caption">Balance</Typography></div>
              </TableCell>
              <TableCell align="right">
                <Button color="primary" component={RouterLink} size="small" to={`/wallets/${wallet.id}/summary`} variant="outlined">
                  View
                  </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

AccountWallet.propTypes = {
  className: PropTypes.string,
};

export default AccountWallet;
